import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
export type StyleProps = {};
export const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: () => ({
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      background: 'linear-gradient(180deg, #fff 0%, #cfd7e5 82.13%)',
      padding: '32px',
    }),
    title: {
      alignSelf: 'center',
      marginTop: 45,
      fontSize: '32px',
      lineHeight: '38px',
    },
    description: {
      alignSelf: 'center',
      marginTop: 16,
    },
    button: {
      marginTop: 'auto',
    },
    img: {
      alignSelf: 'center',
      margin: 0,
    },
  })
);
